export default __webpack_public_path__ + "static/media/logo-formation-ssiap1-300x300.a10cb9c8.png";